export default __webpack_public_path__ + "static/media/screws-world-front.07f9375f.jpeg";